import { render, staticRenderFns } from "./UserLocations.vue?vue&type=template&id=590da20f&"
import script from "./UserLocations.vue?vue&type=script&lang=js&"
export * from "./UserLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports